// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1t-FI","label":"SetPasswdForm_label__1dcMJ"};